var formater = {
  thousandComma: function(number) {
    if (number === 0) {
      return 0;
    } else if (!number) {
      return '';
    }
    let num = number.toString();
    num = num.replace(/,/g, '');
    const decimalPoint = num.indexOf('.') > -1;
    num = num.split('.');
    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(num[0])) {
      num[0] = num[0].replace(pattern, '$1,$2');
    }
    if (decimalPoint) {
      num = num[0] + '.' + (num[1] || '');
    } else {
      num = num[0];
    }
    return num;
  },
  leadingIntZero: function(value) {
    value = parseInt(value);
    if (!isNaN(value)) {
      return `${value < 10 ? '0' : ''}${value.toString()}`;
    }
    return value.toString();
  },
  percentage: function(value) {
    return `${(value * 100).toString()}%`;
  },
  percentageRoundTwo: function(value) {
    value = Math.round(value * 100 * 100) / 100; //取到小數點第二位
    return `${value.toString()}%`;
  },
  decimal: function(num, decimal) {
    decimal = decimal || 4;

    const newDecimal = Math.pow(10, decimal);
    return Math.round(num * newDecimal) / newDecimal;
  },
};

export default formater;
